/* ============================================================
   NOBILAÉ — Moteur d'animation éditoriale
   Remplace les comportements de base (nav, reveal, menu)
   et ajoute : stagger, parallaxe, révélation d'images,
   titres mot-à-mot, barre de progression.
   ============================================================ */

(function(){
  "use strict";

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Nav : effet au scroll ---------- */
  const header = document.getElementById("header");
  if(header){
    const onScroll = () => header.classList.toggle("scrolled", window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive:true });
  }

  /* ---------- Menu mobile ---------- */
  const navToggle = document.getElementById("navToggle");
  const navLinks = document.querySelector(".nav-links");
  if(navToggle && navLinks){
    // Pour échapper au stacking context du header, on déplace le menu dans <body>
    const navParent = navLinks.parentElement;
    const navPlaceholder = document.createComment("nav-anchor");
    navParent.insertBefore(navPlaceholder, navLinks);

    function openMenu(){
      document.body.appendChild(navLinks);
      navLinks.classList.add("mobile-open");
      navToggle.classList.add("is-open");
      document.body.classList.add("nav-locked");
      navToggle.setAttribute("aria-expanded", "true");
    }
    function closeMenu(){
      navLinks.classList.remove("mobile-open");
      navToggle.classList.remove("is-open");
      document.body.classList.remove("nav-locked");
      navToggle.setAttribute("aria-expanded", "false");
      // Remettre le menu à sa place d'origine (pour le desktop)
      navParent.insertBefore(navLinks, navPlaceholder.nextSibling);
    }

    navToggle.addEventListener("click", () => {
      if(navLinks.classList.contains("mobile-open")) closeMenu();
      else openMenu();
    });

    // Accordéon tactile : sur mobile, taper un élément à sous-menu le déplie
    navLinks.querySelectorAll(".has-dropdown > a, .has-mega > a").forEach(function(trigger){
      trigger.addEventListener("click", function(e){
        // Seulement en mode mobile (menu ouvert en plein écran)
        if(!navLinks.classList.contains("mobile-open")) return;
        const parent = trigger.parentElement;
        // Si le lien parent a une vraie destination, on déplie d'abord au lieu de naviguer
        if(!parent.classList.contains("submenu-open")){
          e.preventDefault();
          // Referme les autres
          navLinks.querySelectorAll(".submenu-open").forEach(function(el){
            if(el !== parent) el.classList.remove("submenu-open");
          });
          parent.classList.add("submenu-open");
        }
        // 2e tap : laisse le lien fonctionner normalement (navigation)
      });
    });

    // Fermer le menu quand on clique un lien final (sans sous-menu)
    navLinks.querySelectorAll("a").forEach(function(a){
      a.addEventListener("click", function(){
        const parent = a.parentElement;
        const hasSub = parent.classList.contains("has-dropdown") || parent.classList.contains("has-mega");
        if(!hasSub && navLinks.classList.contains("mobile-open")){
          closeMenu();
        }
      });
    });
  }

  /* ---------- Découpe des titres en mots animables ---------- */
  if(!reduceMotion){
    document.querySelectorAll("[data-words]").forEach(el => {
      const html = el.innerHTML;
      // On découpe sur les espaces tout en préservant les <em>...</em>
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const out = [];
      tmp.childNodes.forEach(node => {
        if(node.nodeType === 3){
          node.textContent.split(/(\s+)/).forEach(part => {
            if(part.trim() === ""){ out.push(part); }
            else { out.push(`<span class="word"><span>${part}</span></span>`); }
          });
        } else {
          const cls = node.tagName ? node.tagName.toLowerCase() : "";
          const inner = node.textContent;
          out.push(`<span class="word ${cls === 'em' ? 'is-em' : ''}"><span style="${cls==='em'?'font-style:italic;color:var(--cuivre-clair);font-weight:400;':''}">${inner}</span></span>`);
        }
      });
      el.innerHTML = out.join("");
    });
  }

  /* ---------- IntersectionObserver : reveals + stagger + words ---------- */
  const revealTargets = document.querySelectorAll(
    ".reveal, .reveal-left, .reveal-right, .reveal-scale, .stagger-parent, .img-reveal, .line-reveal, .flourish, [data-words]"
  );

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        const el = entry.target;
        el.classList.add("in-view");
        // Animation des mots à l'intérieur d'un titre data-words
        if(el.hasAttribute("data-words")){
          const words = el.querySelectorAll(".word");
          words.forEach((w, i) => {
            w.style.transitionDelay = (i * 0.05) + "s";
            requestAnimationFrame(() => w.classList.add("in-view"));
          });
        }
        io.unobserve(el);
      }
    });
  }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });

  revealTargets.forEach(el => io.observe(el));

  /* ---------- Parallaxe douce ---------- */
  const parallaxEls = Array.from(document.querySelectorAll(".parallax"));
  let ticking = false;

  function applyParallax(){
    const vh = window.innerHeight;
    parallaxEls.forEach(el => {
      const speed = parseFloat(el.dataset.speed || "0.12");
      const rect = el.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const offset = (center - vh / 2) * speed * -1;
      el.style.setProperty("--py", offset.toFixed(1) + "px");
    });
    ticking = false;
  }

  if(parallaxEls.length && !reduceMotion){
    window.addEventListener("scroll", () => {
      if(!ticking){
        window.requestAnimationFrame(applyParallax);
        ticking = true;
      }
    }, { passive:true });
    applyParallax();
  }

  /* ---------- Barre de progression de lecture ---------- */
  const progress = document.querySelector(".read-progress");
  if(progress){
    const updateProgress = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop;
      const max = h.scrollHeight - h.clientHeight;
      const pct = max > 0 ? (scrolled / max) * 100 : 0;
      progress.style.width = pct.toFixed(1) + "%";
    };
    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive:true });
  }

})();
